
<template>
  <div>
    <dd-loading />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GoogleDriveAuthSuccess',

  data() {
    return {
      email: '',
      token: '',
      gerror: '',
    }
  },

  head(): any {
    return {
      title: 'DoneDone2 - Google Drive Authentication',
    }
  },

  created() {
    const routeParams =
      this.$route && this.$route.query ? this.$route.query : ''

    if (routeParams) {
      if (routeParams.gemail) {
        this.email = routeParams.gemail as string
      }
      if (routeParams.gat) {
        this.token = routeParams.gat as string
      }
      if (routeParams.gerror) {
        this.gerror = routeParams.gerror as string
      }

      if (routeParams.gerror) {
        this.gerror = routeParams.gerror as string
      }

      window.localStorage.setItem(
        'googleAuth',
        JSON.stringify({
          email: this.email,
          apiAuthToken: this.token,
          gerror: this.gerror,
        }),
      )
      window.close()
    }
  },
})
</script>
